import { Text } from 'src/onboarding/components/typography/Text/Text';
import styles from '../style.module.scss';
import { ReactComponent as ActiveSVG } from '../../../assets/images/check.svg';
import { ReactComponent as InactiveSVG } from '../../../assets/images/Subtract.svg';
interface BodyType {
  label: string;
  image: JSX.Element;
}

export const BodyTypeCard = ({
  bodyType,
  isSelected,
  onSelect,
}: {
  bodyType: BodyType;
  isSelected: boolean;
  onSelect: () => void;
}) => (
  <div className={`${styles.card} ${isSelected && styles.selected}`} onClick={onSelect}>
    <div className={styles.image}>{bodyType.image}</div>
    <div className={styles.label}>
      <Text semibold style={{ width: 95 }}>
        {bodyType.label}
      </Text>
      {isSelected ? <ActiveSVG /> : <InactiveSVG />}
    </div>
  </div>
);
